import DateTime from "../../Components/DateTime";
import PageTabs from "../../Components/PageTabs";
import React, { useState, useRef, useContext, useEffect } from "react";
import "react-quill/dist/quill.snow.css";
import EnterKeyPress from "../../Props/EnterKeyPress";
import ModalQueryName from "../../ModalBox/ModalQueryName";
import MiscellaneousMaster from "../../Master/AccountMaster/MiscellaneousMaster";
import Query from "../../../API/APIServices/Query";
import Loader from "../../Props/Loader";
import MyContext from "../../MyContext";
import AlertBoxError from "../../Props/AlertBoxError";
import AlertBox from "../../Props/AlertBox";
import MainButton from "../../Props/MainButton";
import SmsTemplate from "../../../API/APIServices/SmsTemplate";
import MiscellaneousMasterApi from "../../../API/APIServices/MiscellaneousMaster";
import TransactionTypeSetting from "../../../API/APIServices/TransactionTypeSetting";
import Status from "../../../API/APIServices/Status";
import MastersModalBox from "../../Props/MastersModalBox";
import CreateCustomTemplate from "./CustomTemplate";

function SmsTemplate1(props) {
  /***********{title}***************/
  useState(() => {
    document.title = "SMS Template";
  }, []);

  const {
    OpenAlertBox,
    alertBox,
    OpenAlertBoxEdit,
    alertBoxEdit,
    alertBoxError,
    OpenAlertBoxError,
    UserDetails,
  } = useContext(MyContext);

  const [TransactypaTypemasterList, setTransactypaTypemasterList] = useState(
    []
  );
  const [VouchermasterList, setVouchermasterList] = useState([]);
  const [isModalOpenmeta, setisModalOpenmeta] = useState();
  useEffect(() => {
    const filterdata = async () => {
      var data = await TransactionTypeSetting.GetAllTransactionTypeMaster();
      if (data && data.length > 0) {
        const TransactionData = data.filter((x) => x.typeId === 227);
        const VoucherData = data.filter((x) => x.typeId === 228);
        setTransactypaTypemasterList(TransactionData);
        setVouchermasterList(VoucherData);
      }
    };

    filterdata();
  }, []);

  useEffect(() => {
    if (UserDetails && UserDetails.userRoleCreateBtnVisible === false) {
      // Get all elements with the class name "dm_4"
      const elements = document.getElementsByClassName("dm_4");

      // Loop through all the elements and set their display style to "none"
      for (let i = 0; i < elements.length; i++) {
        elements[i].style.display = "none";
      }
    }
  }, [UserDetails]);

  //**********{show hide}*****************//

  const [isInputVisiblam3, setInputVisiblam3] = useState(false);
  const handleToggleChangam3 = () => {
    setInputVisiblam3(!isInputVisiblam3);
  };

  //**********{show hide Y/N}*****************//
  const [isModalOpenEcom, setModalOpenEcom] = useState(false);

  const [QueryData, setQueryData] = useState({});

  const fetchdata = async () => {
    const data = await Query.getQuery();
    if (data) {
      setQueryData(data);
    } else {
      console.log(data);
    }
  };

  useEffect(() => {
    fetchdata();
  }, []);

  const [loading, setLoading] = useState(false);

  const showselectOption51 = () => {
    setModalOpenEcom(!isModalOpenEcom);
  };

  const [errorMessages, setErrorMessages] = useState({});

  const [inputValuesForQuery, setInputValuesForQuery] = useState({
    id: "",
    title: "",
    query: "",
    query2: "",
    query3: "",
    isActive: true,
  });

  const [inputValuesForSmS, setinputValuesForSmS] = useState({
    id: "",
    title: "",
    templateForSMSAPI: "",
    templateId: "",
    queryName: "",
    fieldName: "",
    smsTemplateBody: "",
    templateForWhatsappAPI: "",
    whatsappLanguage: "",
    messageHeaderSection: "",
    messageBodySection: "",
    smsType: "",
    templateForFormDetails: "",
    isActive: true,

    headerPlaceholders: [],
    bodyPlaceholders: [],
    headerExamples: [],
    bodyExamples: [],

    headerMappings: [],
    bodyMappings: [],
  });

  const [inputValuesForMsgTemplate, setInputValuesForMsgTemplate] = useState({
    smsType: "",
    template: "",
    smsTypeName: "",
    templateName: "",
  });

  const [controlType] = useState(173);

  const toFriendlyName = (fieldName) => {
    return fieldName
      .replace(/([A-Z])/g, " $1")
      .replace(/^./, (str) => str.toUpperCase());
  };

  const validateInput = (fieldName) => {
    const fieldValue = inputValuesForQuery[fieldName];

    if (
      !fieldValue ||
      (typeof fieldValue === "string" && fieldValue.trim() === "")
    ) {
      setErrorMessages((prevErrors) => ({
        ...prevErrors,
        [fieldName]: `${toFriendlyName(fieldName)} field is required`,
      }));
      return false;
    }

    return true;
  };
  const [SmsTemplateData, setSmsTemplateData] = useState({});

  const DeleteSmsTemplateData = async (id) => {
    const Data = await SmsTemplate.DeleteAssignTemplateToMsgType(id);
    if (Data) {
      alert("Deleted Sucessfully");
      await fetchTEmplateData();
    } else {
      alert("Failed to Deleted");
    }
  };

  const fetchTEmplateData = async () => {
    const templateData = await SmsTemplate.GetAssignTemplates();
    setSmsTemplateData(templateData);
  };

  useEffect(() => {
    fetchTEmplateData();
  }, []);

  const fieldNames = [];

  const SaveQuery = () => {
    let allValid = true;
    fieldNames.forEach((fieldName) => {
      const isValid = validateInput(fieldName);
      if (!isValid) {
        allValid = false;
      }
    });
    if (allValid) {
      setLoading(true);
      const isSuccess = Query.insertQuery(inputValuesForQuery);
      if (isSuccess) {
        OpenAlertBox();
        setLoading(false);
        setInputValuesForQuery({
          title: "",
          query: "",
          query2: "",
          query3: "",
          isActive: true,
        });
        alert("Your Query is saved");
        fetchdata();
      } else {
        alert("error while updating");
      }
    }
  };

  const updateQuery = () => {
    let allValid = true;
    fieldNames.forEach((fieldName) => {
      const isValid = validateInput(fieldName);
      if (!isValid) {
        allValid = false;
      }
    });
    if (allValid) {
      setLoading(true);
      const isSuccess = Query.updateQuery(inputValuesForQuery);
      if (isSuccess) {
        OpenAlertBox();
        setLoading(false);
        setInputValuesForQuery({
          title: "",
          query: "",
          query2: "",
          query3: "",
          isActive: true,
        });
        alert("Your Query is saved");
        fetchdata();
      } else {
        alert("error while updating");
      }
    }

    // else {
    //     setLoading(true);
    //     const isSuccess = Query.insertQuery(inputValuesForQuery);
    //     if (isSuccess) {
    //         setLoading(false);
    //         OpenAlertBox();
    //     } else {
    //         alert("Error inserting data");
    //     }
    // }
    // setInputValuesForQuery({
    //     name: "",
    //     printName: "",
    // });
  };

  const deleteQuery = () => {
    setLoading(true);
    const isSuccess = Query.deleteQuery(inputValuesForQuery);
    if (isSuccess) {
      OpenAlertBox();
      setLoading(false);
      setInputValuesForQuery({
        title: "",
        query: "",
        query2: "",
        query3: "",
        isActive: true,
      });
      alert("Your Query is saved");
      fetchdata();
    } else {
      alert("error while updating");
    }
  };

  const [SmsData, setSmsData] = useState([]);

  const SaveSms = () => {
    let allValid = true;
    fieldNames.forEach((fieldName) => {
      const isValid = validateInput(fieldName);
      if (!isValid) {
        allValid = false;
      }
    });
    if (allValid) {
      setLoading(true);

      let isSuccess = false;

      if (isSmsTemplateEdit == false) {
        isSuccess = SmsTemplate.insertSmsTemplate(inputValuesForSmS);
      } else {
        isSuccess = SmsTemplate.updateSmsTemplate(inputValuesForSmS);
      }

      if (isSuccess) {
        OpenAlertBox();
        setLoading(false);
        setinputValuesForSmS({
          title: "",
          templateForSMSAPI: "",
          templateId: "",
          queryName: "",
          fieldName: "",
          smsTemplateBody: "",
          templateForWhatsappAPI: "",
          whatsappLanguage: "",
          messageHeaderSection: "",
          messageBodySection: "",
          smsType: "",
          templateForFormDetails: "",
          isActive: true,
        });
        alert("Your Sms is saved");
        fetchdata();
      } else {
        alert("error while updating");
      }
    }
  };

  const saveMessageTemplate = async () => {
    const smssave = await SmsTemplate.MessageTemplate(
      inputValuesForMsgTemplate
    );
    console.log(smssave);
    if (smssave) {
      alert("Yout Template is saved");
      fetchTEmplateData();
    } else {
      alert("error");
    }
  };

  const [isSmsTemplateEdit, setIsSmsTemplateEdit] = useState(false);
  const [getByIdData, setgetByIdData] = useState({});

  const getSmsTypeByid = async (event) => {
    var id = event.target.value;
    var data = await SmsTemplate.getSmsTemplateById(id);
    console.log(data);

    if (data) {
      setinputValuesForSmS({
        id: data.id,
        title: data.title,
        templateForSMSAPI: data.templateForSMSAPI,
        templateId: data.templateId,
        queryName: data.queryName,
        fieldName: data.fieldName,
        smsTemplateBody: data.smsTemplateBody,
        templateForWhatsappAPI: data.templateForWhatsappAPI,
        whatsappLanguage: data.whatsappLanguage,
        messageHeaderSection: data.messageHeaderSection,
        messageBodySection: data.messageBodySection,
        smsType: data.smsType,
        templateForFormDetails: data.templateForFormDetails,
        isActive: true,
      });
      setgetByIdData(data);
      setIsSmsTemplateEdit(true);
      fetchSmsTemplate(data.queryName);
    } else {
      alert("data is not available");
      setinputValuesForSmS({
        id: "",
        title: "",
        templateForSMSAPI: "",
        templateId: "",
        queryName: "",
        fieldName: "",
        smsTemplateBody: "",
        templateForWhatsappAPI: "",
        whatsappLanguage: "",
        messageHeaderSection: "",
        messageBodySection: "",
        smsType: "",
        templateForFormDetails: "",
        isActive: true,
      });
    }
  };

  useEffect(() => {
    const fetchSmsTemplate1 = async () => {
      var SmsTemplates = await SmsTemplate.getSmsTemplate();
      console.log(SmsTemplates);
      if (SmsTemplates) {
        setSmsData(SmsTemplates);
      } else {
      }
    };
    fetchSmsTemplate1();
  }, []);
  const [metaTemplates, setMetaTemplates] = useState([]);

  // const getHeaderText = (components = []) => {
  //   const header = components.find((c) => c.type === "HEADER");
  //   return header?.text || "";
  // };

  // const getBodyText = (components = []) => {
  //   const body = components.find((c) => c.type === "BODY");
  //   return body?.text || "";
  // };

  // const handleMetaTemplateChange = (selectedId) => {
  //   const selectedTemplate = metaTemplates.find((t) => t.id === selectedId);
  //   if (selectedTemplate) {
  //     setinputValuesForSmS((prev) => ({
  //       ...prev,
  //       templateId: selectedTemplate.id,
  //       templateForWhatsappAPI: selectedTemplate.name || "",
  //       whatsappLanguage: selectedTemplate.language || "",
  //       // messageHeaderSection: getHeaderText(selectedTemplate.components),
  //       smsTemplateBody: getBodyText(selectedTemplate.components),
  //     }));
  //   }
  // };
  const extractPlaceholders = (text) => {
    const regex = /{{\d+}}/g;
    const matches = text.match(regex);
    return matches ? [...new Set(matches)] : [];
  };

  const handleMetaTemplateChange = (selectedId) => {
    const selectedTemplate = metaTemplates.find((t) => t.id === selectedId);
    if (!selectedTemplate) return;

    const header = selectedTemplate.components.find((c) => c.type === "HEADER");
    const body = selectedTemplate.components.find((c) => c.type === "BODY");

    const headerPlaceholders = extractPlaceholders(header?.text || "");
    const bodyPlaceholders = extractPlaceholders(body?.text || "");

    const headerExamples = header?.example?.body_text?.[0] || [];
    const bodyExamples = body?.example?.body_text?.[0] || [];

    setinputValuesForSmS((prev) => ({
      ...prev,
      templateForWhatsappAPI: selectedTemplate.name || "",
      whatsappLanguage: selectedTemplate.language || "",
      smsTemplateBody: body?.text || "",
      headerPlaceholders,
      bodyPlaceholders,
      headerExamples,
      bodyExamples,
    }));
  };

  const fetchData = async () => {
    ;
    try {
      const response = await SmsTemplate.GetAllMetaTemplates();
      console.log("response", response);
      // const data = [
      //   {
      //     name: "order_ready",
      //     parameter_format: "POSITIONAL",
      //     components: [
      //       {
      //         type: "BODY",
      //         text: "Order ready for pickup: Dear,{{1}}  your order is ready. Kindly collect at your convenience. Thank you. Lens2cart.",
      //         example: {
      //           body_text: [["Girish Panchal"]],
      //         },
      //       },
      //     ],
      //     language: "en_US",
      //     status: "APPROVED",
      //     category: "UTILITY",
      //     id: "1132171058444537",
      //   },
      //   {
      //     name: "order_ready",
      //     parameter_format: "POSITIONAL",
      //     components: [
      //       {
      //         type: "BODY",
      //         text: "Hello Name,\n\nYour order is ready for pickup.",
      //       },
      //       {
      //         type: "FOOTER",
      //         text: "Store 001 - Lens2cart",
      //       },
      //       {
      //         type: "BUTTONS",
      //         buttons: [
      //           {
      //             type: "PHONE_NUMBER",
      //             text: "Connect with us",
      //             phone_number: "+254740170093",
      //           },
      //         ],
      //       },
      //     ],
      //     language: "en",
      //     status: "APPROVED",
      //     category: "UTILITY",
      //     id: "1191095462197390",
      //   },
      //   {
      //     name: "order_confirmed",
      //     parameter_format: "POSITIONAL",
      //     components: [
      //       {
      //         type: "HEADER",
      //         format: "DOCUMENT",
      //         example: {
      //           header_handle: [
      //             "https://scontent.whatsapp.net/v/t61.29466-34/482766814_1818899585557278_9062079912676201322_n.pdf?ccb=1-7&_nc_sid=8b1bef&_nc_ohc=lmnFc3-Xk5cQ7kNvwHOfBca&_nc_oc=Adk2uxtjkcHGk4jfcp8dAsT9uhlS94x2XEOXdZXC8UczGU0WMySDvHb6fDQ8MnB6xZSwELimiAQvmlNLhfNQlUAb&_nc_zt=3&_nc_ht=scontent.whatsapp.net&edm=AH51TzQEAAAA&_nc_gid=EnEvYWld4UmdQ4o_phaIAw&oh=01_Q5Aa1gEdF92ScJZH647oDgivgGAemWUh_1_K98lt-xv-94tEIQ&oe=685CD6B7",
      //           ],
      //         },
      //       },
      //       {
      //         type: "BODY",
      //         text: "Dear {{1}}, Thank you for your purchase worth of KSh. {{2}},Voucher No: {{3}}, Advance: KSh. {{4}}, Balance: KSh. {{5}}, Please respond back in case you need invoice sent out on whatsapp.",
      //         example: {
      //           body_text: [["Girish parmar", "4500", "3983", "1000", "3500"]],
      //         },
      //       },
      //     ],
      //     language: "en_US",
      //     status: "APPROVED",
      //     category: "UTILITY",
      //     id: "1782256989221538",
      //   },
      //   {
      //     name: "sale_invoice_pdf",
      //     previous_category: "UTILITY",
      //     parameter_format: "POSITIONAL",
      //     components: [
      //       {
      //         type: "HEADER",
      //         format: "DOCUMENT",
      //         example: {
      //           header_handle: [
      //             "https://scontent.whatsapp.net/v/t61.29466-34/491870414_1034585958555482_6224070662425278866_n.pdf?ccb=1-7&_nc_sid=8b1bef&_nc_ohc=if3Tg5dYRPgQ7kNvwG9Dqob&_nc_oc=Adk12jZxjYtOrKFdd1ZJsp3WwKHqB1I-qKT57qtSWGg6dn9rlLfeDS6c_R3xrMUbrJ8fydTUqdVNRXWCG_PcW4fd&_nc_zt=3&_nc_ht=scontent.whatsapp.net&edm=AH51TzQEAAAA&_nc_gid=EnEvYWld4UmdQ4o_phaIAw&oh=01_Q5Aa1gH3V-iIEBbQ2mmCxgsGu1Ie1gAd8ILwz3G6WgthF7KI_g&oe=685CB4E5",
      //           ],
      //         },
      //       },
      //       {
      //         type: "BODY",
      //         text: "We appreciate your business and hope to see you again soon! Need help? Contact us anytime.",
      //       },
      //       {
      //         type: "FOOTER",
      //         text: "Reply STOP to unsubscribes",
      //       },
      //     ],
      //     language: "en_US",
      //     status: "APPROVED",
      //     category: "MARKETING",
      //     correct_category: "MARKETING",
      //     id: "1034585955222149",
      //   },
      //   {
      //     name: "order_recieved_",
      //     parameter_format: "POSITIONAL",
      //     components: [
      //       {
      //         type: "BODY",
      //         text: "Dear {{1}}, \n\nThank you for your purchase worth of KSh. {{2}}.\n\nVoucher No: {{3}}, Advance: KSh. {{4}}, Balance: KSh. {{5}}.\n\nPlease send a message if you need the invoice for the purchase on whatsapp.",
      //         example: {
      //           body_text: [["Girish panchal", "1800", "1234", "800", "1000"]],
      //         },
      //       },
      //     ],
      //     language: "en",
      //     status: "APPROVED",
      //     category: "MARKETING",
      //     id: "989988729760223",
      //   },
      //   {
      //     name: "hello_world",
      //     parameter_format: "POSITIONAL",
      //     components: [
      //       {
      //         type: "HEADER",
      //         format: "TEXT",
      //         text: "Hello World",
      //       },
      //       {
      //         type: "BODY",
      //         text: "Welcome and congratulations!! This message demonstrates your ability to send a WhatsApp message notification from the Cloud API, hosted by Meta. Thank you for taking the time to test with us.",
      //       },
      //       {
      //         type: "FOOTER",
      //         text: "WhatsApp Business Platform sample message",
      //       },
      //     ],
      //     language: "en_US",
      //     status: "APPROVED",
      //     category: "UTILITY",
      //     id: "602422952434031",
      //   },
      //   {
      //     name: "invoice",
      //     parameter_format: "POSITIONAL",
      //     components: [
      //       {
      //         type: "HEADER",
      //         format: "DOCUMENT",
      //         example: {
      //           header_handle: [
      //             "https://scontent.whatsapp.net/v/t61.29466-34/484821920_1308139740415933_6751351844915747166_n.pdf?ccb=1-7&_nc_sid=8b1bef&_nc_ohc=hd12KWdJtlUQ7kNvwHHTR4V&_nc_oc=AdngOFDm8yX4zqbi81lj7uQ_NeVEw3GZqd8yfmHXH4u8TIVrBVZklOCstpojjx912NONPQ1NU9YtkEXtvOXtNZoN&_nc_zt=3&_nc_ht=scontent.whatsapp.net&edm=AH51TzQEAAAA&_nc_gid=EnEvYWld4UmdQ4o_phaIAw&oh=01_Q5Aa1gEJVEoOt99O8KuJPQdLaOf7hoydH4PQL0ND5erwRPcudA&oe=685CBECD",
      //           ],
      //         },
      //       },
      //       {
      //         type: "BODY",
      //         text: "Hi {{1}},\n\nThank you for your visit.\n\nAttached invoice for your purchase.",
      //         example: {
      //           body_text: [["Girish panchal"]],
      //         },
      //       },
      //       {
      //         type: "FOOTER",
      //         text: "Lens2cart",
      //       },
      //     ],
      //     language: "en",
      //     status: "APPROVED",
      //     category: "UTILITY",
      //     id: "1308139737082600",
      //   },
      //   {
      //     name: "feedback",
      //     parameter_format: "POSITIONAL",
      //     components: [
      //       {
      //         type: "BODY",
      //         text: "Feedback - Dear {{1}}, Thank you for your trust on us. We hope you have a wonderful experience with your new product. Lens2cart.",
      //         example: {
      //           body_text: [["Girish parmar"]],
      //         },
      //       },
      //     ],
      //     language: "en_US",
      //     status: "APPROVED",
      //     category: "UTILITY",
      //     sub_category: "CUSTOM",
      //     id: "1311127206598664",
      //   },
      // ];
      // setMetaTemplates(data);
      if (response) {
        setMetaTemplates(response.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const handleHeaderMappingChange = (index, value) => {
    setinputValuesForSmS((prev) => {
      const newHeaderMappings = [...(prev.headerMappings || [])];
      newHeaderMappings[index] = value;
      return { ...prev, headerMappings: newHeaderMappings };
    });
  };

  const handleBodyMappingChange = (index, value) => {
    setinputValuesForSmS((prev) => {
      const newBodyMappings = [...(prev.bodyMappings || [])];
      newBodyMappings[index] = value;
      return { ...prev, bodyMappings: newBodyMappings };
    });
  };

  // const handleAddHeaderMapping = (index) => {
  //   setinputValuesForSmS((prev) => {
  //     const value = prev.headerMappings?.[index] || "";
  //     // const placeholder = prev.headerPlaceholders[index];
  //     const toAppend = `@${value}`;
  //     return {
  //       ...prev,
  //       messageHeaderSection:
  //         (prev.messageHeaderSection || "") + toAppend + "\n",
  //     };
  //   });
  // };

  const handleAddPlaceholders = () => {
    // const headerMessage = inputValuesForSmS.headerPlaceholders
    //   .map((_, i) => inputValuesForSmS.headerMappings[i] || "")
    //   .join(", ");
    // const bodyMessage = inputValuesForSmS.bodyPlaceholders
    //   .map((_, i) => inputValuesForSmS.bodyMappings[i] || "")
    //   .join(", ");

    const headerMessage = inputValuesForSmS.headerPlaceholders
      .map((_, i) =>
        inputValuesForSmS.headerMappings[i]
          ? `@${inputValuesForSmS.headerMappings[i]}`
          : ""
      )
      .join(" ");

    const bodyMessage = inputValuesForSmS.bodyPlaceholders
      .map((_, i) =>
        inputValuesForSmS.bodyMappings[i]
          ? `@${inputValuesForSmS.bodyMappings[i]}`
          : ""
      )
      .join(" ");

    setinputValuesForSmS((prev) => ({
      ...prev,
      messageHeaderSection: headerMessage,
      messageBodySection: bodyMessage,
    }));
  };

  // const handleAddBodyMapping = (index) => {
  //   setinputValuesForSmS((prev) => {
  //     const value = prev.bodyMappings?.[index] || "";
  //     // const placeholder = prev.bodyPlaceholders[index];
  //     const toAppend = `@${value}`;
  //     return {
  //       ...prev,
  //       messageBodySection: (prev.messageBodySection || "") + toAppend + "\n",
  //     };
  //   });
  // };

  const handleInputChangeForQuery = (event) => {
    const { name, value } = event.target;
    console.log(`Changing ${name} to ${value}`);

    setInputValuesForQuery((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
    setErrorMessages((prevErrors) => ({ ...prevErrors, [name]: "" }));
  };
  const [selectedFieldName, setSelectedFieldName] = useState();

  const handleInputChangeForSms1 = (event) => {
    const { name, value } = event.target;
    console.log(`Changing ${name} to ${value}`);

    setinputValuesForSmS((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
    setSelectedFieldName(value);
    setErrorMessages((prevErrors) => ({ ...prevErrors, [name]: "" }));
  };
  const handleInputChangeForSms = (event) => {
    const { name, value } = event.target;
    console.log(`Changing ${name} to ${value}`);

    setinputValuesForSmS((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));

    //alert(name)
    setErrorMessages((prevErrors) => ({ ...prevErrors, [name]: "" }));
    if (name === "queryName") {
      fetchSmsTemplate(value);
    }
  };

  const handleInputChangeForMsgTemplate = (event) => {
    const { name, value } = event.target;
    console.log(`Changing ${name} to ${value}`);

    /*setInputValuesForMsgTemplate((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));*/

    // Find the selected option's text (name)
    const selectedText = event.target.options[event.target.selectedIndex].text;

    setInputValuesForMsgTemplate((prevValues) => {
      if (name === "smsType") {
        return {
          ...prevValues,
          smsType: value,
          smsTypeName: selectedText,
        };
      } else if (name === "template") {
        return {
          ...prevValues,
          template: value,
          templateName: selectedText,
        };
      }
      return prevValues;
    });

    setErrorMessages((prevErrors) => ({ ...prevErrors, [name]: "" }));
  };

  //*******************{modal box}******************/ /

  const [isModalOpen, setModalOpen] = useState(false);
  const showModal = () => {
    setModalOpen(true);
  };
  const hideModal = () => {
    setModalOpen(false);
  };

  const [isPrintName, setPrintName] = useState(false);
  const showPrintName = () => {
    setPrintName(!isPrintName);
  };

  //****************{modal box}***************/ /

  //*****************{Save Button}************************//

  const [isHovered, setHovered] = useState(false);
  const handleMouseEnter = () => {
    setHovered(true);
  };
  const handleMouseLeave = () => {
    setHovered(false);
  };
  // **********************{Press Enter Button}************************

  const input1Ref = useRef(null);
  const input2Ref = useRef(null);
  const input3Ref = useRef(null);
  const input4Ref = useRef(null);
  const input5Ref = useRef(null);
  const input6Ref = useRef(null);
  const input7Ref = useRef(null);

  const handleKeyPress = (event, nextInputRef) => {
    if (event.key === "Enter") {
      event.preventDefault();
      if (nextInputRef.current) {
        nextInputRef.current.focus();
      }
    }
  };

  //**********{query Name modal box}*****************//
  const [isModalOpenQuery, setModalOpenQuery] = useState(false);
  const showModalQuery = () => {
    setModalOpenQuery(true);
  };
  const hideModalQuery = () => {
    setModalOpenQuery(false);
  };

  //**********{Form modal box}*****************//
  const [isModalOpenForm, setModalOpenForm] = useState(false);
  const showModalForm = () => {
    setModalOpenForm(true);
  };
  const hideModalForm = () => {
    setModalOpenForm(false);
  };

  const [TimeSLot, setTimeSLot] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      {
        try {
          const controlType = 173;
          const data = await MiscellaneousMasterApi.GetMiscellaneousMaster(
            controlType
          );
          setTimeSLot(data);
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      }
    };
    fetchData();
  }, [isModalOpenForm]);

  const [AllStatusData, setAllStatusData] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      {
        try {
          const data = await Status.GetStatus();
          setAllStatusData(data);
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      }
    };
    fetchData();
  }, [isModalOpenForm]);

  const [FieldName, setFieldName] = useState([]);
  const fetchSmsTemplate = async (id) => {
    var FieldName = await Query.getQueryColumnName(id);
    console.log(FieldName);
    setFieldName(FieldName);
    if (FieldName) {
    } else {
    }
  };

  const changetablevalue = (e) => {
    const value = e.target.value;
    console.log(value);
    setFieldName(value);
    handleInputChangeForSms(e);
  };

  function handleAddBtnClick() {
    const currentText = inputValuesForSmS.smsTemplateBody || "";
    const newText = `${currentText.trim()} @${selectedFieldName}`;

    setinputValuesForSmS((prevState) => ({
      ...prevState,
      smsTemplateBody: newText,
    }));

    console.log("New text:", newText);
  }

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.altKey && event.key.toLowerCase() === "q") {
        console.log("Alt + q");
        hideModalQuery();
        hideModalForm();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    // Cleanup the event listener on unmount
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);
  const [isCustomModalOpen, setIsCustomModalOpen] = useState(false);
  const modalOverlayStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  };

  const modalContentStyle = {
    backgroundColor: "#fff",
    padding: "20px",
    borderRadius: "8px",
    width: "75vw", // 3/4 of viewport width
    height: "75vh",
    // minWidth: "300px",
    // maxWidth: "90%",
    // textAlign: "center",
    boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
  };
  return (
    <div>
      <PageTabs />

      {/* < EnterKeyPress /> */}
      <div className="panel-heading">
        <div className="panel-head-title">
          <h2 className="panel-title">SMS Template</h2>
        </div>
        {/* *******************Save Button****************** */}
        <MainButton SaveButton={SaveSms} PageName="Masters" />

        {/* *******************Top Buttons****************** */}
        {/* <div className="panel-head-button">
          <div className="col_1">
            <div>
              <div className="button-m5">
                <button
                  id="SaveBtnMain"
                  className={`save-button-main-save ${
                    isHovered ? "hovered" : ""
                  }`}
                  onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave}
                >
                  Save
                  <i
                    id="step-2"
                    className="fa-solid fa-file-export im-icon-white"
                  ></i>
                  {isHovered && (
                    <div className="hover-textSave">
                      <i className="fa-solid fa-sort-up ItemIconHover"></i>
                      Alt + Enter
                    </div>
                  )}
                </button>
              </div>
            </div>

            <div className="button-m5">
              <button className="save-button-main">
                Reset
                <i id="step-2" className="fa-solid fa-rotate im-icon-2"></i>
              </button>
            </div>
          </div>
        </div> */}
      </div>
      {/* *******************Modal Box End****************** */}
      <div>
        <DateTime />
      </div>
      <div className="content_box">
        <div className="company-info-top-im">
          <div className="tab-head">
            <div id="tabs">
              <div className="tab-content-box">
                <div className="tab-content-1">
                  <div className="company-info-top-left">
                    <div
                      className="company_info-text-im"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <span>SMS Details</span>
                      <button
                        style={{
                          padding: "4px 10px",
                          fontSize: "12px",
                          backgroundColor: "#1976d2",
                          color: "white",
                          border: "none",
                          borderRadius: "4px",
                          cursor: "pointer",
                        }}
                        onClick={() => setIsCustomModalOpen(true)}
                      >
                        Create
                      </button>
                    </div>
                    <div className="HeadContentItemgroup">
                      {(() => {
                        return (
                          <div className="input-box-m11">
                            <input
                              ref={input1Ref}
                              onKeyDown={(event) =>
                                handleKeyPress(event, input2Ref)
                              }
                              className="modify_im_input mode_limit mode_category"
                              type="text"
                              required
                              onChange={changetablevalue}
                              value={inputValuesForSmS.title}
                              name="title"
                            />
                            <label className="modifyTextLabel">Title</label>
                          </div>
                        );
                      })()}
                      {/* {isPrintName && ( */}
                      <div className="input-box-m11">
                        <select
                          name=""
                          id=""
                          ref={input2Ref}
                          onKeyDown={(event) =>
                            handleKeyPress(event, input3Ref)
                          }
                          className="modify_im_input mode_category"
                          type="text"
                          onChange={(e) => getSmsTypeByid(e)}
                        >
                          <option value="">--Select--</option>
                          {Array.isArray(SmsData) && SmsData.length > 0 ? (
                            SmsData.map((sms) => (
                              <option value={sms.id} key={sms.id}>
                                {sms.title}
                              </option>
                            ))
                          ) : (
                            <option>Blank</option>
                          )}
                        </select>
                        <label className="ItemMasterLabelFix">Template</label>
                      </div>
                      {/* )} */}

                      <div className="input-box-m11">
                        <input
                          ref={input3Ref}
                          onKeyDown={(event) =>
                            handleKeyPress(event, input4Ref)
                          }
                          className="modify_im_input mode_category"
                          type="text"
                          onChange={handleInputChangeForSms}
                          value={inputValuesForSmS.templateForSMSAPI}
                          name="templateForSMSAPI"
                          required
                        />
                        <label className="modifyTextLabel">
                          Template For SMS API
                        </label>
                      </div>

                      <div className="input-box-m11">
                        <input
                          ref={input4Ref}
                          onKeyDown={(event) =>
                            handleKeyPress(event, input5Ref)
                          }
                          className="modify_im_input mode_limit mode_category"
                          type="text"
                          required
                          onChange={handleInputChangeForSms}
                          value={inputValuesForSmS.templateId}
                          name="templateId"
                        />
                        <label className="modifyTextLabel">Template ID</label>
                      </div>
                      <div className="input-box-m11 dm_3">
                        <select
                          ref={input5Ref}
                          onKeyDown={(event) =>
                            handleKeyPress(event, input6Ref)
                          }
                          className="modify_im_input mode_category"
                          type="text"
                          required
                          onChange={handleInputChangeForSms}
                          value={inputValuesForSmS.queryName}
                          name="queryName"
                        >
                          <option>--Select--</option>
                          {Array.isArray(QueryData) ? (
                            QueryData.map((Query) => (
                              <option value={Query.id} key={Query.id}>
                                {Query.title}
                              </option>
                            ))
                          ) : (
                            <option>Blank</option>
                          )}
                        </select>
                        <label className="ItemMasterLabelFix">Query Name</label>
                        <div onClick={showModalQuery}>
                          <i className="fa-solid fa-circle-plus dm_4"></i>
                        </div>
                      </div>

                      <div className="input-box-m11 dm_3">
                        <select
                          ref={input6Ref}
                          onKeyDown={(event) =>
                            handleKeyPress(event, input7Ref)
                          }
                          className="modify_im_input mode_category"
                          type="text"
                          required
                          onChange={handleInputChangeForSms1}
                          value={inputValuesForSmS.fieldName}
                          name="fieldName"
                        >
                          <option>--Select--</option>
                          <option>FirmName</option>
                          <option>FirmShortName</option>
                          <option>FirmPrintName</option>
                          <option>FirmAddress1</option>
                          <option>FirmAddress2</option>
                          <option>FirmAddress3</option>
                          <option>FirmMobileNo</option>
                          <option>FirmEmail</option>
                          <option>FirmWebsite</option>
                          <option>FirmGstTinNo</option>
                          <option>FirmCstNo</option>
                          <option>FirmPinCode</option>
                          <option>FirmTermsCondition</option>
                          {Array.isArray(FieldName) && FieldName.length > 0 ? (
                            FieldName.map((sms) => (
                              <option value={sms.id} key={sms.id}>
                                {sms}
                              </option>
                            ))
                          ) : (
                            <option>Blank</option>
                          )}
                        </select>
                        <label className="ItemMasterLabelFix">Field Name</label>

                        <div className="Sms_Save">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <button
                              className="AddBtn_Sms"
                              onClick={handleAddBtnClick}
                            >
                              Add
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="input-box-Im">
                        <div className="input-box-m2">
                          <label className="" style={{ color: "red" }}>
                            Please Do Not Use Any Special Characters In Text
                          </label>
                        </div>
                      </div>
                    </div>
                    {/* ********************{old}****************** */}

                    <div className="">
                      <div className="input-box-tab-head Sms-Text-Box">
                        <div className="input-box-m2">
                          <textarea
                            className="modify_im_textarea mode_category2 Sms-Template-box"
                            type="text"
                            placeholder=""
                            required
                            onChange={handleInputChangeForSms}
                            value={inputValuesForSmS.smsTemplateBody}
                            name="smsTemplateBody"
                          />
                          {/* <label className="modify_p_text-fix">Meta Title</label> */}
                        </div>
                      </div>

                      <div className="input-box-m11">
                        <select
                          name=""
                          id=""
                          ref={input2Ref}
                          onKeyDown={(event) =>
                            handleKeyPress(event, input3Ref)
                          }
                          className="modify_im_input mode_category"
                          type="text"
                          onChange={(e) => {
                            handleMetaTemplateChange(e.target.value);
                            setisModalOpenmeta(true);
                          }}
                        >
                          <option value="">--Select--</option>
                          {metaTemplates.length > 0 ? (
                            metaTemplates.map((template) => (
                              <option value={template.id} key={template.id}>
                                {template.name}
                              </option>
                            ))
                          ) : (
                            <option>Blank</option>
                          )}
                        </select>
                        <label className="ItemMasterLabelFix">
                          Meta` Template
                        </label>
                      </div>

                      <div className="HeadContentItemgroup">
                        <div className="input-box-m11">
                          <input
                            className="modify_im_input mode_category"
                            type="text"
                            required
                            onChange={handleInputChangeForSms}
                            value={inputValuesForSmS.templateForWhatsappAPI}
                            name="templateForWhatsappAPI"
                          />
                          <label className="modifyTextLabel">
                            Template Name For Whatsapp API
                          </label>
                        </div>

                        <div className="input-box-m11">
                          <input
                            className="modify_im_input mode_limit mode_category"
                            type="text"
                            required
                            onChange={handleInputChangeForSms}
                            value={inputValuesForSmS.whatsappLanguage}
                            name="whatsappLanguage"
                          />
                          <label className="modifyTextLabel">
                            Template Language For Whatsapp API
                          </label>
                        </div>
                      </div>
                      <div className="input-box-tab-head Sms-Text-Box">
                        <div className="input-box-m2">
                          <textarea
                            className="modify_im_textarea mode_category2 sms-header-box"
                            type="text"
                            placeholder="Message Header Section"
                            required
                            value={inputValuesForSmS.messageHeaderSection}
                            onChange={handleInputChangeForSms}
                            name="messageHeaderSection"
                          />
                          {/* <label className="modify_p_text-fix">Meta Keywords</label> */}
                        </div>
                      </div>
                      <div className="input-box-tab-head Sms-Text-Box">
                        <div className="input-box-m2">
                          <textarea
                            className="modify_im_textarea mode_category2 sms-header-box"
                            type="text"
                            placeholder="Message Body Section"
                            required
                            onChange={handleInputChangeForSms}
                            value={inputValuesForSmS.messageBodySection}
                            name="messageBodySection"
                          />
                          {/* <label className="modify_p_text-fix">Meta Description</label> */}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="company-info-top-right"
                    style={{ width: "50%" }}
                  >
                    <div>
                      <div className="company_info-text-im">Form Details</div>
                      <div className="">
                        <div className="input-box-Im input-height2">
                          <div className="input-box-m11 dm_3">
                            <select
                              className="modify_im_input mode_category"
                              type="text"
                              required
                              value={inputValuesForMsgTemplate.smsType}
                              name="smsType"
                              onChange={handleInputChangeForMsgTemplate}
                            >
                              <option>--Select--</option>
                              {TransactypaTypemasterList.length > 0 &&
                                TransactypaTypemasterList?.map((item) => (
                                  <option value={item.id} key={item.id}>
                                    {item.masterName}
                                  </option>
                                ))}
                              {VouchermasterList.length > 0 &&
                                VouchermasterList?.map((item) => (
                                  <option value={item.id} key={item.id}>
                                    {item.masterName}
                                  </option>
                                ))}
                              {AllStatusData.length > 0 &&
                                AllStatusData?.map((item) => (
                                  <option value={item.id} key={item.id}>
                                    {item.name}
                                  </option>
                                ))}
                              {Array.isArray(TimeSLot) &&
                              TimeSLot.length > 0 ? (
                                TimeSLot.map((data) => (
                                  <option value={data.id} key={data.id}>
                                    {data.name || ""}
                                  </option>
                                ))
                              ) : (
                                <></>
                              )}
                            </select>
                            <label className="ItemMasterLabelFix">
                              SMS Type
                            </label>
                            <div onClick={showModalForm}>
                              <i className="fa-solid fa-circle-plus dm_4"></i>
                            </div>
                          </div>

                          <div className="input-box-m11 dm_3">
                            <select
                              className="modify_im_input mode_category"
                              type="text"
                              required
                              value={inputValuesForMsgTemplate.template}
                              name="template"
                              onChange={handleInputChangeForMsgTemplate}
                            >
                              <option>--Select--</option>
                              {Array.isArray(SmsData) && SmsData.length > 0 ? (
                                SmsData.map((sms) => (
                                  <option value={sms.id} key={sms.id}>
                                    {sms.title}
                                  </option>
                                ))
                              ) : (
                                <option>Blank</option>
                              )}
                            </select>
                            <label className="ItemMasterLabelFix">
                              Template
                            </label>
                            {/* <div>
                                  <i className="fa-solid fa-circle-plus dm_4"></i>
                              </div> */}
                            <div className="Sms_Save">
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <button
                                  className="SaveBtn_Sms"
                                  onClick={saveMessageTemplate}
                                >
                                  Save
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-12">
                        <div className="table-resposive">
                          <table
                            id="tblTransactionList"
                            className="table_ord_mod table-bordered1"
                            frame="box"
                          >
                            <thead
                              textAlign="center"
                              className="thead_scroll_orderlist table-tbody"
                            >
                              <tr className="">
                                <th className="td_col6 td_width_sms">
                                  {" "}
                                  <div className="table_head_mmb ">
                                    <div
                                      className="table_head_mmb1"
                                      style={{ textAlign: "center" }}
                                    >
                                      S.No.
                                    </div>
                                  </div>{" "}
                                </th>
                                <th className="td_col6">
                                  {" "}
                                  <div className="table_head_OrderList">
                                    <div
                                      className="table_head_mmb1"
                                      style={{ textAlign: "center" }}
                                    >
                                      SMS Type
                                    </div>
                                  </div>{" "}
                                </th>
                                <th className="td_col6">
                                  {" "}
                                  <div className="table_head_OrderList">
                                    <div
                                      className="table_head_nnb1"
                                      style={{ textAlign: "center" }}
                                    >
                                      Template
                                    </div>
                                  </div>{" "}
                                </th>
                                <th className="td_col6 td_width_sms">Dlt</th>
                              </tr>
                            </thead>
                            <tbody className="tbody_body_m1">
                              {SmsTemplateData && SmsTemplateData.length > 0 ? (
                                SmsTemplateData.map((sms, index) => (
                                  <tr
                                    key={index}
                                    className="table_tbody_Order_List"
                                  >
                                    <td className="td_col6">{index + 1}</td>
                                    <td
                                      className="td_col6"
                                      style={{ textAlign: "center" }}
                                    >
                                      {sms.smstypE_Name}
                                    </td>
                                    <td
                                      className="td_col6"
                                      style={{ textAlign: "center" }}
                                    >
                                      {sms.title}
                                    </td>
                                    <td
                                      className=""
                                      style={{ textAlign: "center" }}
                                    >
                                      {/* <button className="btn-table1"> */}
                                      <i
                                        onClick={() =>
                                          DeleteSmsTemplateData(sms.id)
                                        }
                                        className="fa-solid fa-trash delete-btn"
                                      ></i>
                                      {/* </button> */}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <></>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div>
                        {isModalOpenQuery && (
                          <MastersModalBox closeModal={hideModalQuery}>
                            <ModalQueryName
                              SaveQuery={SaveQuery}
                              handleInputChangeForQuery={
                                handleInputChangeForQuery
                              }
                              inputValuesForQuery={inputValuesForQuery}
                              setInputValuesForQuery={setInputValuesForQuery}
                              updateQuery={updateQuery}
                              deleteQuery={deleteQuery}
                              closeModal={hideModalQuery}
                            />
                          </MastersModalBox>
                        )}
                      </div>
                      <div>
                        {isModalOpenForm && (
                          <MastersModalBox closeModal={hideModalForm}>
                            <MiscellaneousMaster
                              isBackButton={false}
                              isLogoutButton={true}
                              SaveButtonName={"Save/F4"}
                              isF4ListenForSave={true}
                              controlType={controlType}
                            />
                          </MastersModalBox>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div></div>
      </div>
      {isCustomModalOpen && (
        <div style={modalOverlayStyle}>
          <div style={modalContentStyle}>
            <CreateCustomTemplate setIsCustomModalOpen={setIsCustomModalOpen} />
          </div>
        </div>
      )}
      {alertBoxEdit && (
        <AlertBox
          HeadingTop="Updated"
          Heading="Your Item Master is Updated"
          onYesClick={OpenAlertBoxEdit}
          singleButton={true}
          OpenAlertBox={OpenAlertBoxEdit}
        />
      )}

      {alertBoxError && (
        <AlertBoxError
          HeadingTop="ERROR"
          Heading="Error While Updating Data"
          onYesClick={OpenAlertBoxError}
          singleButton={true}
          OpenAlertBox={OpenAlertBoxError}
        />
      )}
      {loading && <Loader />}

      {isModalOpenmeta && (
        <div className="modal-overlay-metamodal">
          <div className="modal-content-metamodal">
            <h3>Template Placeholder Mapping</h3>
            <div className="input-box-m11 dm_3">
              <select
                ref={input5Ref}
                onKeyDown={(event) => handleKeyPress(event, input6Ref)}
                className="modify_im_input mode_category"
                type="text"
                required
                onChange={handleInputChangeForSms}
                value={inputValuesForSmS.queryName}
                name="queryName"
              >
                <option>--Select--</option>
                {Array.isArray(QueryData) ? (
                  QueryData.map((Query) => (
                    <option value={Query.id} key={Query.id}>
                      {Query.title}
                    </option>
                  ))
                ) : (
                  <option>Blank</option>
                )}
              </select>
              <label className="ItemMasterLabelFix">Query Name</label>
            </div>

            {inputValuesForSmS.headerPlaceholders.length > 0 && (
              <div>
                <h4>Header Placeholder Mappings</h4>
                {inputValuesForSmS.headerPlaceholders.map(
                  (placeholder, index) => (
                    <div className="placeholder-row-metamodal" key={index}>
                      <label>{placeholder}</label>
                      <select
                        value={inputValuesForSmS.bodyMappings[index] || ""}
                        onChange={(e) =>
                          handleHeaderMappingChange(index, e.target.value)
                        }
                      >
                        <option value="">-- Select --</option>
                        {Array.isArray(FieldName) && FieldName.length > 0 ? (
                          FieldName.map((sms) => (
                            <option value={sms.id} key={sms.id}>
                              {sms}
                            </option>
                          ))
                        ) : (
                          <option>Blank</option>
                        )}
                      </select>
                      {inputValuesForSmS.headerExamples?.length > index && (
                        <div className="placeholder-example-metamodal">
                          Example: {inputValuesForSmS.headerExamples[index]}
                        </div>
                      )}
                    </div>
                  )
                )}
              </div>
            )}

            {inputValuesForSmS.bodyPlaceholders.length > 0 && (
              <div>
                <h4>Body Placeholder Mappings</h4>
                {inputValuesForSmS.bodyPlaceholders.map(
                  (placeholder, index) => (
                    <div className="placeholder-row-metamodal" key={index}>
                      <div className="meta-flex">
                        {" "}
                        <label>{placeholder} -</label>
                        <select
                          value={inputValuesForSmS.bodyMappings[index] || ""}
                          onChange={(e) =>
                            handleBodyMappingChange(index, e.target.value)
                          }
                        >
                          <option value="">-- Select --</option>
                          {Array.isArray(FieldName) && FieldName.length > 0 ? (
                            FieldName.map((sms) => (
                              <option value={sms.id} key={sms.id}>
                                {sms}
                              </option>
                            ))
                          ) : (
                            <option>Blank</option>
                          )}
                        </select>
                      </div>
                      {inputValuesForSmS.bodyExamples?.length > index && (
                        <div className="placeholder-example-metamodal">
                          Example: {inputValuesForSmS.bodyExamples[index]}
                        </div>
                      )}
                    </div>
                  )
                )}
              </div>
            )}

            <button
              className="modal-close-btn-metamodal"
              onClick={() => setisModalOpenmeta(false)}
            >
              Close
            </button>

            <button
              className="modal-close-btn-metamodal"
              type="button"
              onClick={() => handleAddPlaceholders()}
            >
              Add
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default SmsTemplate1;
